"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default(_ref) {
  var sendTimeout = _ref.sendTimeout;
  return sendTimeout;
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfZGVmYXVsdCIsIl9yZWYiLCJzZW5kVGltZW91dCIsImV4cG9ydHMiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc2VsZWN0b3JzL3NlbmRUaW1lb3V0LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgUmVkdXhTdGF0ZSB9IGZyb20gJy4uL3R5cGVzL2ludGVybmFsL1JlZHV4U3RhdGUnO1xuXG5leHBvcnQgZGVmYXVsdCAoeyBzZW5kVGltZW91dCB9OiBSZWR1eFN0YXRlKTogbnVtYmVyID0+IHNlbmRUaW1lb3V0O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7ZUFFZSxTQUFBQSxTQUFBQyxJQUFBO0VBQUEsSUFBR0MsV0FBVyxHQUFBRCxJQUFBLENBQVhDLFdBQVc7RUFBQSxPQUEyQkEsV0FBVztBQUFBO0FBQUFDLE9BQUEsY0FBQUgsUUFBQSJ9